import { Component, Input } from "@angular/core";
import { MenuSection } from "src/app/Header/Types/menu.interface";

@Component({
  selector: "app-breadcrum-option",
  templateUrl: "breadcrum-link-option.component.html",
  styleUrls: ["breadcrum-link-option.component.scss"],
})
export class BreadcrumLinkOptionComponent {
  @Input() public menuOptions: MenuSection[];
  @Input() public dashboardTitle: string;
  public defaultIcon: string = "assets/images/icons/empty-icon.svg";
}
